import Helper from '@ember/component/helper';

export default class EverHelper extends Helper {
  ever;
  compute(params) {
    // Warning: don't code golf this out of reactivity to its dependent params
    for (const param of params) {
      if (param) {
        this.ever = true;
      }
    }
    return this.ever;
  }
}
